import Home from './pages/home.vue';
import Login from './views/Login.vue';

export const PublicRoutes = [
	{
		path: '/',
		component: Home,
		props: true,
		name: 'home',
	},
	{
		path: '/login',
		component: Login,
		name: 'login',
		meta: {
			auth: false
		}
	},
]; 